/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Announcement = {
    properties: {
        id: {
    type: 'number',
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        employeeId: {
    type: 'number',
    isRequired: true,
},
        title: {
    type: 'string',
    isRequired: true,
},
        media: {
    type: 'string',
},
        description: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'string',
},
    },
};